import TimelineNode from './TimelineNode.component';

export default TimelineNode;